import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';



@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor() { }


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
        .pipe(
          catchError((err: HttpErrorResponse) => {

            let errorMessage = '';
             if (err.error instanceof ErrorEvent) {
               // client-side error
               errorMessage = `Error: ${err.error.message}`;
             } else {
               // server-side error
               errorMessage = `Error Code: ${err.status}\nMessage: ${err.message}`;
            }
            
            //return throwError(errorMessage);
            return throwError(err);
        }))
    }
}
